import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

type TabData = {
  name: string;
  href?: string;
  content: React.ReactNode;
};

type CustomTabsProps = {
  tabs: TabData[];
};

function TabbedContainer({ tabs }: CustomTabsProps) {
  const [searchParams] = useSearchParams();

  return (
    <Tab.Group defaultIndex={searchParams.get('tab') === 'group' ? 1 : 0}>
      <Tab.List className="flex pl-2 -mb-px space-x-8">
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            className={({ selected }) =>
              clsx(
                selected
                  ? 'border-oncolensOrange-500 text-oncolensOrange-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
              )
            }>
            {tab.name}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="">
        {Object.values(tabs).map((tab, idx) => (
          <Tab.Panel
            key={idx}
            className={clsx(
              'rounded-md bg-white p-3 min-h-[32rem]',
              'ring-opacity-60 focus:outline-none',
            )}>
            {tab?.content}
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
}

export default TabbedContainer;
